import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import { useActivitiesContext } from '@user/features/Activity/context'
import * as React from 'react'
import { ActivityHistoryList } from './atoms/ActivityHistoryList/ActivityHistoryList'

export function ActivityHistoryTree() {
  const [{ history }] = useActivitiesContext()
  return (
    <Table>
      <TableBody>
        <ActivityHistoryList history={history} />
      </TableBody>
    </Table>
  )
}
